var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4F46E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 16.5833H13.0833V17.75H11.3333V16.5833ZM14.25 17.75H16V16.5833H14.25V17.75ZM11.3333 20.0833H13.0833V18.9167H11.3333V20.0833ZM14.25 20.0833H16V18.9167H14.25V20.0833ZM11.3333 13.0833H13.0833V11.9167H11.3333V13.0833ZM14.25 13.0833H16V11.9167H14.25V13.0833ZM11.3333 15.4167H13.0833V14.25H11.3333V15.4167ZM14.25 15.4167H16V14.25H14.25V15.4167ZM23 13.6667V23H9V10.75C9 10.2859 9.18437 9.84075 9.51256 9.51256C9.84075 9.18437 10.2859 9 10.75 9H16.5833C17.0475 9 17.4926 9.18437 17.8208 9.51256C18.149 9.84075 18.3333 10.2859 18.3333 10.75V11.9167H21.25C21.7141 11.9167 22.1592 12.101 22.4874 12.4292C22.8156 12.7574 23 13.2025 23 13.6667ZM17.1667 10.75C17.1667 10.5953 17.1052 10.4469 16.9958 10.3375C16.8864 10.2281 16.738 10.1667 16.5833 10.1667H10.75C10.5953 10.1667 10.4469 10.2281 10.3375 10.3375C10.2281 10.4469 10.1667 10.5953 10.1667 10.75V21.8333H17.1667V10.75ZM21.8333 13.6667C21.8333 13.512 21.7719 13.3636 21.6625 13.2542C21.5531 13.1448 21.4047 13.0833 21.25 13.0833H18.3333V21.8333H21.8333V13.6667ZM19.5 17.75H20.6667V16.5833H19.5V17.75ZM19.5 20.0833H20.6667V18.9167H19.5V20.0833ZM19.5 15.4167H20.6667V14.25H19.5V15.4167Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBm);
export default __webpack_public_path__ + "static/media/iconBM.9e26f7bd7c564fefc65cbb5b891210c2.svg";
export { ForwardRef as ReactComponent };